import { useState, useContext } from "react";
import CredentialsHeader from "@/components/header/Header";
import CredentialsFooter from "@/components/footer/Footer";
import { useTranslation } from "react-i18next";
import CallCenterSvg from "@/assets/images/call-center.svg";
import {
  ContactCenterRequest,
  ContactCenterOption,
} from "@/models/continente-credentials/loyaltycard/ContactCenterRequest";
import { useLocation, useHistory } from "react-router-dom";
import { IdentifierValidationResponse } from "@/models/continente-credentials/loyaltycard/IdentifierValidationResponse";
import { loyaltyCardService } from "@/services/continente-credentials/loyaltycard/LoyaltyCardService";
import { DigitalAssetContext } from "../../../contexts/continente-credentials/DigitalAssetContext";
import MantraButton from "@/components/mantra-button/MantraButton";
import NeedHelpButton from "@/components/need-help-button/need-help-button";
import ErrorMessage from "@/components/error-message/error-message";

export default function LoyaltyCardContactCenter() {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation<IdentifierValidationResponse>();
  const [loading, setLoading] = useState(false);
  const digitalAssetContext = useContext(DigitalAssetContext);
  const [error, setError] = useState("");

  const handleChoosedOption = async (
    contactCenterOption: ContactCenterOption
  ) => {
    setLoading(true);

    const contactCenterRequest: ContactCenterRequest = {
      contactCenterOption: contactCenterOption,
    };

    if (
      contactCenterRequest.contactCenterOption === ContactCenterOption.CALL &&
      digitalAssetContext.digitalAsset.isMobile === true
    ) {
      await window.open("tel:+911111111", "_self");
    }

    try {
      const response = await loyaltyCardService.loyaltyCardCallCenterOption(
        contactCenterRequest,
        location.state != null ? location.state.nextStep : ""
      );
      if (response.kind === "success") {
        history.push(response.value.nextStep.substring(4), response.value);
      }
      if (response.kind === "error") {
        switch (response.code) {
          case "300007":
            setError(t("identification_verification.input_error"));
            break;
          default:
            setError(t("common.unexpected_error"));
        }
      } else {
        setError(t("common.unexpected_error"));
      }

      setLoading(false);
    } catch (e) {
      setError(t("common.unexpected_error"));
      setLoading(false);
    }
  };
  return (
    <div className="flex flex-col gap-12 pb-2">
      <div className="justify-center">
        <CredentialsHeader
          title={t("call_center_loyalty_card.header_title")}
          subtitle={t("call_center_loyalty_card.header_message")}
          showLoading={loading}
        />
      </div>

      <div className="flex justify-center items-center">
        <img src={CallCenterSvg} className="w-56 h-56" alt="" />
      </div>

      <div className="flex justify-center">
        <MantraButton
          text={t("call_center_loyalty_card.button_call_center")}
          type="button"
          size="large"
          onClick={() => handleChoosedOption(ContactCenterOption.CALL)}
        />
      </div>

      <div className="flex justify-center">
        <MantraButton
          text={t("call_center_loyalty_card.another_card")}
          type="button"
          color="secondary"
          onClick={() =>
            handleChoosedOption(ContactCenterOption.ANOTHER_LOYALTY_CARD)
          }
        />
      </div>
      {digitalAssetContext.digitalAsset.requiredCardAssociation ? (
        <div className="flex justify-center">
          <MantraButton
            text={t("call_center_loyalty_card.new_card")}
            type="button"
            color="secondary"
            onClick={() =>
              handleChoosedOption(ContactCenterOption.NEW_LOYALTY_CARD)
            }
          />
        </div>
      ) : (
        <div className="flex justify-center">
          <MantraButton
            text={t("call_center_loyalty_card.whithout_card")}
            type="button"
            color="secondary"
            onClick={() =>
              handleChoosedOption(ContactCenterOption.NO_LOYALTY_CARD)
            }
          />
        </div>
      )}
      <ErrorMessage errorString={error} />
      <NeedHelpButton />
      <div className="flex flex-col">
        <CredentialsFooter
          contextualInformationVisible={false}
          footerAppsWebsitesIconsVisible={false}
        />
      </div>
    </div>
  );
}
